import { get, post } from '@/services/http';

interface SurveyResponsePayload {
  answer: string;
  answerLabel: string;
  freeText?: string;
}

class FeatureUnlockService {
  async checkUnlockStatus(features?: string[]): Promise<any> {
    const params = features ? { features: features.join(',') } : {};
    const response: any = await get('/feature-unlocks/status', params);
    return response?.data;
  }

  async createUnlock(
    featureCode: string,
    surveyQuestion: string,
    surveyResponse: SurveyResponsePayload,
    flowVariant?: string
  ): Promise<any> {
    const response: any = await post('/feature-unlocks/unlock', {
      featureCode,
      surveyQuestion,
      surveyResponse,
      flowVariant,
    });
    return response?.data;
  }

  async listUnlocks(): Promise<any> {
    const response: any = await get('/feature-unlocks/list');
    return response?.data;
  }

  async updateReviewStatus(
    featureCode: string,
    reviewRequested?: boolean,
    reviewOutcome?: string
  ): Promise<any> {
    const payload: any = { featureCode };
    if (reviewRequested !== undefined) payload.reviewRequested = reviewRequested;
    if (reviewOutcome !== undefined) payload.reviewOutcome = reviewOutcome;
    const response: any = await post('/feature-unlocks/review-status', payload);
    return response?.data;
  }
}

export const featureUnlockService = new FeatureUnlockService();
